import { serverURL, apiGet } from '../../../../../common/utils/fetch_utils';

export async function getLoanReasons() {
  const response = await apiGet(`${serverURL}/v1/leads/loanReasons`);
  if (!response || !response.success) throw new Error(response.error);
  return response;
}
